var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-card w3-round w3-white"},[_c('div',{staticClass:"w3-container"},[(_vm.currUser)?_c('h4',{staticClass:"w3-center"},[_vm._v(_vm._s(_vm.currUser.name))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }